import React from 'react';

const Modal = ({ isOpen, onClose, children, actions }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center" onClick={onClose}>
      <div className="bg-white p-4 rounded-lg shadow-xl relative max-w-3xl w-full" onClick={e => e.stopPropagation()}>
        <div>
          {children}
        </div>

        {actions && (
          <div className="mt-4 flex justify-end space-x-3">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;